import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, computed, watch } from 'vue';
    import ModalTemplate from '@/components/layouts/ModalTemplate.vue';
    import LandPlotModalTop from './LandPlotModalTop.vue';
    import LandPlotModalBottom from './LandPlotModalBottom.vue';
    import { landPlotStore } from '@/store/modules/LandPLot';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['close', 'openFilter'],
  setup(__props) {

    

    const indexActiveSlider = ref(0);
    const isActivePlotModalGalleryFullScreen = ref(false);
    const isActiveHouseModalGalleryFullScreen = ref(false);

    const landPlot = computed(() => {
        return landPlotStore.LAND_PLOT_CARD_IN_MODAL;
    });

    function openInFullScreenPlotModalGallery(data: number) {
        indexActiveSlider.value = data;
        isActivePlotModalGalleryFullScreen.value = true;
    }

    function openInFullScreenHouseModalGallery(data: number) {
        indexActiveSlider.value = data;
        isActiveHouseModalGalleryFullScreen.value = true;
    }

    watch(isActivePlotModalGalleryFullScreen, value => {
        if (
            isActivePlotModalGalleryFullScreen.value ||
            isActiveHouseModalGalleryFullScreen.value
        )
            document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'auto';
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalTemplate, {
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
    onOpenFilter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('openFilter'))),
    darkOverlay: true,
    closeBtn: true,
    backToListBtn: true,
    scrollBodyLock: true
  }, {
    default: _withCtx(() => [
      _createVNode(LandPlotModalTop, {
        landPlot: landPlot.value,
        onOpenInFullScreenPlotModalGallery: openInFullScreenPlotModalGallery,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, null, 8, ["landPlot"]),
      (landPlot.value && landPlot.value.house)
        ? (_openBlock(), _createBlock(LandPlotModalBottom, {
            key: 0,
            landPlot: landPlot.value,
            onOpenInFullScreenHouseModalGallery: 
                openInFullScreenHouseModalGallery
            
          }, null, 8, ["landPlot", "onOpenInFullScreenHouseModalGallery"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})